import { Get } from '../utils/request';

export async function getStoreList(payload = {}) {
  const params = payload;
  params.data = params.data || {};
  return Get('/shopify/store/list', params);
}
